import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { dataContext } from "../../Context/contextProvider";
import { observer } from "mobx-react";
import { getDatabaseListAPI } from "../../Services/Http/ConfigService";
import { RegoServerItem } from "../../Models/RegoServerItem";
interface Step2Props {
  onStepComplete?: (dbKey: string) => void;
  onNavigateToLogin?: () => void;
}

const Step2 = observer(({ onStepComplete, onNavigateToLogin }: Step2Props) => {
  const [localDbKey, setLocalDbKey] = useState<string>("");
  const [loadedDbs, setLoadedDbs] = useState<RegoServerItem[]>([]);
  const dataStore = useContext(dataContext);
  const myRef = useRef<HTMLSelectElement>(null);

  const getDbList = useCallback(async () => {
    try {
      if (!dataStore.serverUrl) {
        return onNavigateToLogin?.();
      }
      const dbs = await getDatabaseListAPI(dataStore.serverUrl);
      if (dbs) {
        setLoadedDbs(dbs);
      } else {
        setLoadedDbs([]);
      }
      if (!localDbKey) {
        dataStore.dbKey = null;
      }
    } catch {
      setLocalDbKey("");
      setLoadedDbs([]);
    }
  }, [dataStore, localDbKey, onNavigateToLogin]);

  useEffect(() => {
    getDbList();
    if (!localDbKey) {
      setTimeout(() => myRef.current?.focus(), 100);
    }
  }, [dataStore.serverUrl, localDbKey, getDbList]);

  const handleOnChangeDbList = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const odbKey = e.target.value;
    setLocalDbKey(odbKey);
    onStepComplete?.(odbKey);
  };
  return (
    <>
      <div className="row row-border-top pt-2 mb-4">
        <div className="col-lg-4 offset-lg-4 col-md-6 offset-md-3 col-sm-8 offset-sm-2 col-12">
          <div>Company</div>
          <div>
            <div className="d-flex">
              <select className="form-select" aria-label="Database list" value={localDbKey} onChange={handleOnChangeDbList} ref={myRef}>
                <option value="" key="">
                  Select a company
                </option>
                {loadedDbs.map((db) => (
                  <option value={db.key} key={db.key}>
                    {db.companyCode && db.companyName ? `${db.companyCode} - ${db.companyName}` : db.databaseName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default Step2;
